import type { AutoAssignmentRuleTargetType } from '@ipfabric/utils/schema/labels/autoAssignmentRuleFilters';

export type RuleTargetType = AutoAssignmentRuleTargetType;

export const targetTypeSupportsInherit = (type: RuleTargetType): boolean =>
  type === 'device';

export const inheritForTargetType = (
  type: RuleTargetType,
  inherit: boolean,
): boolean => (targetTypeSupportsInherit(type) ? inherit : false);
